import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, PlusSquareFilled, EditOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Dropdown, Menu, Button, Form, FormInstance, Select, DatePicker, Input } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';
import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";

import { errorMessage, mostrarInfo, successMessage } from "../../../utils/messages";
import { disabledDate } from "../../../utils/utilsFunctions";
import { getDocPdf } from "../../../services/apiDocumentos";
import { IDocumentoPessoaFisica } from "./InterfacePessoaFisica";
import { IChaves } from "../../../Interfaces/Interfaces";
import { IEstado, IPais } from "../../../Interfaces/Localidades";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  documentos: IDocumentoPessoaFisica[];
  paises: IPais[];
  estados: IEstado[];
  setDocumentos: React.Dispatch<React.SetStateAction<IDocumentoPessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}


const { Option } = Select;
const DocPessoaFisica = ({ form, documentos, paises, estados, setDocumentos, manter }: IProps) => {
  const [exibirModalDoc, setExibirModalDoc] = useState(false);
  const [exibirDocCadastrado, setExibirDocCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [campos, setCampos] = useState<ICampos>(); // USADO PARA VERIFICAR OS ATRIBUTOS DOS CAMPOS POR MEIO DE UM JSON.

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();


  useEffect(() => {
    if (documentos && documentos.length === 0) {
      setExibirDocCadastrado("none")
    } else {
      setExibirDocCadastrado("inline")
    }
  }, [documentos]);

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
          ativo: true,
        },
      );

      form.setFieldsValue({
        "idDocumento": "0",
        "chave": chave,
      })
      if (Number(form?.getFieldValue("idPessoaFisicaCertificado")) > 0 && Number(form?.getFieldValue("idDocumento")) === 0) {
        successMessage("O documento será substituído");
      }
    }
  }, [chave]);


  const handlerPais = async (value: any) => {
    form.setFieldsValue({
      nmPais: value.children,
      idPais: value.key,
    });
  };

  const handlerEstados = async (value: any) => {
    form.setFieldsValue({
      nmEstado: value.children,
      idEstado: value.key,
    });
  };

  const controleDaGrid = (botao: string) => {
    if (form.getFieldValue("nuCpf") === "") {
      mostrarInfo("Não é possível incluir novo documento", "CPF ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalDoc(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarDoc = () => {
    /*
    //Task 5444: Desativar armazenamento imagem de documento pessoal
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else */ if (!form.getFieldValue("nmDocumento")) {
      errorMessage("Informe um nome válido de documento.");
    } else if (form.getFieldValue("idPais") === undefined && isCampoRequired("idPais")) {
      errorMessage("O campo país é obrigatório.");
    } else if ((form.getFieldValue("idEstado") === undefined || form.getFieldValue("idPais") === 1) && (isCampoRequired("idEstado"))) {
      errorMessage("O campo UF é obrigatório.");
    } else {
      form
        .validateFields([
          "id",
          "nmDocumento",
          "nuDocumento",
          "nmOrgaoExpedidor",
          "dtExpedicao",
          "dtValidade",
          "idEstado",
          "IdPais",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosDocumento();
          // successMessage("Documento Adicionado");
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido ou não validado");
        });
    }
  };

  function setDadosDocumento() {
    const novo = {
      idPessoaFisicaDocumento: form?.getFieldValue("idPessoaFisicaDocumento"),
      nmDocumento: form?.getFieldValue("nmDocumento") ? form?.getFieldValue("nmDocumento").toUpperCase() : undefined,
      nuDocumento: form?.getFieldValue("nuDocumento") ? form?.getFieldValue("nuDocumento").toUpperCase() : undefined,
      idDocumento: chave,
      documentoChave: fileList,
      nmOrgaoExpedidor: form?.getFieldValue("nmOrgaoExpedidor") ? form?.getFieldValue("nmOrgaoExpedidor").toUpperCase() : undefined,
      dtExpedicao: form?.getFieldValue("dtExpedicao") ? dayjs(form?.getFieldValue("dtExpedicao")).format("YYYY-MM-DD") : "",
      dtValidade: form?.getFieldValue("dtValidade") ? dayjs(form?.getFieldValue("dtValidade")).format("YYYY-MM-DD") : "",
      idEstado: form?.getFieldValue("idEstado") ? form?.getFieldValue("idEstado") : undefined,
      nmEstado: form?.getFieldValue("nmEstado") ? form?.getFieldValue("nmEstado") : undefined,
      idPais: form?.getFieldValue("idPais") ? form?.getFieldValue("idPais") : undefined,
      nmPais: form?.getFieldValue("nmPais") ? form?.getFieldValue("nmPais") : undefined,
      statusReg: 1,
      touched: true,
    };
    if (!novo.idPessoaFisicaDocumento){
      novo.idPessoaFisicaDocumento = -1;
      setDocumentos([
        ...documentos,
        novo,
      ]);
    } else {
      setDocumentos(documentos.map(doc => doc.emEdicao ? novo : doc));
    }

    form.resetFields([
      "id",
      "idPessoaFisicaDocumento",
      "nmDocumento",
      "nuDocumento",
      "nmOrgaoExpedidor",
      "dtExpedicao",
      "dtValidade",
      "idEstado",
      "nmEstado",
      "idPais",
      "nmPais",
    ]);
    setChave(undefined);
    setFileList(undefined);
  }

  const hasCampo = (campo: string) => {
    return campos?.visible ? campos?.visible?.indexOf(campo) > -1 : false
  };

  const isCampoRequired = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.required ? (campos?.required?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const isCampoDisabled = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.disabled ? (campos?.disabled?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const campoDefaultValue = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        if (campos?.default && campos?.default?.[idx] && campos?.default?.[idx] !== "null") {
          if (campo === "nmDocumento") form?.setFieldsValue({ nmDocumento: campos?.default?.[idx] });
          if (campo === "nuDocumento") form?.setFieldsValue({ nuDocumento: campos?.default?.[idx] });
          if (campo === "nmOrgaoExpedidor") form?.setFieldsValue({ nmOrgaoExpedidor: campos?.default?.[idx] });
          return campos?.default?.[idx];
        }
      }
    }
    return undefined;
  };

  const campoDefaultValueSelect = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        if (campos?.default && campos?.default?.[idx] && campos?.default?.[idx] !== "null") {
          if (campo === "idPais") {
            form?.setFieldsValue({ nmPais: campos?.default?.[idx] });
            form?.setFieldsValue({ idPais: campos?.defaultNumberSelect?.[idx] });
          }
          if (campo === "idEstado") {
            form?.setFieldsValue({ nmEstado: campos?.default?.[idx] });
            form?.setFieldsValue({ idEstado: campos?.defaultNumberSelect?.[idx] });
          }
          return campos?.default?.[idx];
        }
      }
    }
    return undefined;
  };

  const campoDefaultValueDatePicker = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        if (campos?.default && campos?.default?.[idx] && campos?.default?.[idx] !== "null") {
          if (campo === "dtExpedicao") form?.setFieldsValue({ dtExpedicao: dayjs(campos?.default?.[idx]) });
          if (campo === "dtValidade") form?.setFieldsValue({ dtValidade: dayjs(campos?.default?.[idx]) });

          return dayjs(campos?.default?.[idx]);
        }
      }
    }
    return undefined;
  }

  const columns = [
    {
      key: "1",
      title: "Nome do Documento",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => <>{IDoc.nmDocumento}</>,
    },
    {
      key: "2",
      title: "Número",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => <>{IDoc.nuDocumento}</>,
    },
    {
      key: "3",
      title: "Órgão de Expedição",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => <>{IDoc.nmOrgaoExpedidor}</>,
    },
    {
      key: "4",
      title: "Data Expedição",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => (
        <>
          {(IDoc.dtExpedicao && IDoc.dtExpedicao !== "" && IDoc.dtExpedicao !== "null") ? dayjs(IDoc.dtExpedicao).format("DD/MM/YYYY") : undefined}
        </>
      ),
    },
    {
      key: "5",
      title: "Data Validade",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => (
        <>
          {(IDoc.dtValidade && IDoc.dtValidade !== "" && IDoc.dtValidade !== "null") ? dayjs(IDoc.dtValidade).format("DD/MM/YYYY") : undefined}
        </>
      ),
    },
    {
      key: "6",
      title: "UF",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => <>{IDoc.nmEstado}</>,
    },
    {
      key: "7",
      title: "País",
      dataIndex: "",
      render: (IDoc: IDocumentoPessoaFisica) => <>{IDoc.nmPais}</>,
    },
    /* Task 5444: Desativar armazenamento imagem de documento pessoal
    {
      key: "111", // PARA ARQUIVOS JÁ SALVOS NA TABELA DE DOCUMENTOS ARQUIVOS
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoPessoaFisica) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento ? IDoc.idDocumento : (IDoc.documentoArquivo?.id!));
          }}
        />
      ),
    },
    */
    {
      key: "8",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoPessoaFisica) => (
        <>
          <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
            <DeleteOutlined
              title="Excluir documento ainda não gravado na base."
              style={{ color: "red", display: (IDoc?.idPessoaFisicaDocumento && IDoc?.idPessoaFisicaDocumento < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
              onClick={() => {
                setDocumentos(documentos.filter((doc) => doc !== IDoc));
              }}
            />
          </div>
          <div style={{ display: manter === 1 || manter === 3 ? "inline" : exibirElementoAcaoAlteracao }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  const dMenu = jsonDropdownMenu.filter(t => IDoc.nmDocumento === t.buttonName.toUpperCase());
                  const tipoDoc = dMenu.length === 0 ? jsonDropdownMenu[4] : dMenu[0];

                  controleDaGrid(tipoDoc.buttonName);
                  setCampos(tipoDoc.campos);
                  IDoc.emEdicao = true;
                  form.setFieldsValue({
                    idPessoaFisicaDocumento: IDoc.idPessoaFisicaDocumento,
                    nmDocumento: IDoc.nmDocumento,
                    nuDocumento: IDoc.nuDocumento,
                    nmOrgaoExpedidor: IDoc.nmOrgaoExpedidor,
                    dtExpedicao: IDoc.dtExpedicao? dayjs(IDoc.dtExpedicao) : undefined,
                    dtValidade: IDoc.dtValidade? dayjs(IDoc.dtValidade) : undefined,
                    idEstado: IDoc.idEstado,
                    nmEstado: estados.find(estado => estado.id === IDoc.idEstado)?.sigla, //chamaram a chave de nmEstado em vez de siglaEstado
                    idPais: IDoc.idPais,
                    nmPais: IDoc.nmPais,
                  });
                }}
              />
          </div>
          <div style={{ display: (IDoc?.idPessoaFisicaDocumento && IDoc?.idPessoaFisicaDocumento > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
            <>
              <PlusSquareFilled
                title="Desmarcar para exclução/inativação"
                style={{ color: "blue", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "none" : "inline" }}
                onClick={() => {
                  IDoc.statusReg = IDoc.statusReg === 1 ? 2 : 1;
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idPessoaFisicaDocumento === IDoc.idPessoaFisicaDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
              <DeleteOutlined
                title="Marcar para exclução/inativação"
                style={{ color: "red", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "inline" : "none" }}
                onClick={() => {
                  IDoc.statusReg = (IDoc.statusReg === 1 ? 2 : 1);
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idPessoaFisicaDocumento === IDoc.idPessoaFisicaDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
            </>

          </div>
        </>
      ),
    },
  ];

  let jsonDropdownMenu = [
    {
      "key": "1",
      "buttonName": "RG",
      "campos": {
        "visible": ["nmDocumento", "nuDocumento", "nmOrgaoExpedidor", "dtExpedicao", "nmEstado", "nmPais", "dtValidade"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["RG", "null", "null", "null", "null", "Brasil", "null"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0, 0, 0, 0, 0, 1, 0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1, 1, 1, 1, 1, 1, 0], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1, 0, 0, 0, 0, 1, 1], // 0 : HABILITADO / 1 : DESABILITADO
      },
    },
    {
      "key": "2",
      "buttonName": "CNH",
      "campos": {
        "visible": ["nmDocumento", "nuDocumento", "nmOrgaoExpedidor", "dtExpedicao", "dtValidade", "nmEstado", "nmPais"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["CNH", "null", "DETRAN", "null", "null", "null", "Brasil"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0, 0, 0, 0, 0, 0, 1], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1, 1, 1, 1, 1, 1, 1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1, 0, 1, 0, 0, 0, 1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "3",
      "buttonName": "Identidade Profissional",
      "campos": {
        "visible": ["nmDocumento", "nuDocumento", "nmOrgaoExpedidor", "dtExpedicao", "dtValidade", "nmEstado", "nmPais"],
        "default": ["Identidade Profissional", "null", "null", "null", "null", "null", "Brasil"],
        "defaultNumberSelect": [0, 0, 0, 0, 0, 0, 1],
        "required": [1, 1, 1, 1, 0, 1, 1],
        "disabled": [1, 0, 0, 0, 0, 0, 1],
      }
    },
    {
      "key": "4",
      "buttonName": "Passaporte",
      "campos": {
        "visible": ["nmDocumento", "nuDocumento", "dtExpedicao", "dtValidade", "nmPais", "nmOrgaoExpedidor", "nmEstado"],
        "default": ["Passaporte", "null", "null", "null", "null", "null", "null"],
        "defaultNumberSelect": [], // SE NÃO EXISTIR UM VALOR PADRÃO PARA UM CAMPO DO TIPO SELECT PODE DEIXAR ESSA ARRAY VAZIA
        "required": [1, 1, 1, 1, 1, 0, 0],
        "disabled": [1, 0, 0, 0, 0, 1, 1],
      }
    },
    {
      "key": "5",
      "buttonName": "Outros",
      "campos": {
        "visible": ["nmDocumento", "nuDocumento", "nmOrgaoExpedidor", "dtExpedicao", "dtValidade", "nmEstado", "nmPais"],
        "default": ["null", "null", "null", "null", "null", "null", "null"],
        "defaultNumberSelect": [],
        "required": [1, 1, 1, 1, 0, 0, 1],
        "disabled": [0, 0, 0, 0, 0, 0, 0],
      }
    },
  ];

  const menuDropdown =
    (
      <Menu>
        {jsonDropdownMenu.map((e, _) => (
          <Menu.Item
            defaultChecked={false}
            key={e.key}
            id={e.key}
            style={{ textAlign: "left" }}
            onClick={() => {

              form.resetFields([
                "id",
                "idPessoaFisicaDocumento",
                "nmDocumento",
                "nuDocumento",
                "nmOrgaoExpedidor",
                "dtExpedicao",
                "dtValidade",
                "nmEstado",
                "idEstado",
                "idPais",
              ]);

              controleDaGrid(e.buttonName);
              setCampos(e.campos)
            }}
          >
            {e.buttonName}
          </Menu.Item>

        ))}
      </Menu>
    )

  return (
    <>
      <Dropdown overlay={menuDropdown} >
        <Button
          style={{ display: exibirElementoAcaoAlteracao }}
          id="key"
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
        >
          Incluir Documento
        </Button>
      </Dropdown>
      <>

        <Modal title="Documento" open={exibirModalDoc}
          style={{ top: 20 }}
          destroyOnHidden={true}
          onCancel={() => {
            controleDaGrid("cancelar");
            setCampos({})

            const ldoc = documentos;
            for (let doc of ldoc){
              if (doc.emEdicao){
                doc.emEdicao = false;
              }
            }
            setDocumentos(ldoc);

            form.resetFields([
              "id",
              "idPessoaFisicaDocumento",
              "nmDocumento",
              "nuDocumento",
              "nmOrgaoExpedidor",
              "dtExpedicao",
              "dtValidade",
              "idEstado",
              "idPais",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarDoc();
          }}
          okText={form.getFieldValue("idPessoaFisicaDocumento")? "Alterar" : "Incluir"}
          okButtonProps={{ shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={24} sm={8}
              style={{ display: hasCampo("nmDocumento") ? 'inline' : 'none' }}
            >
              <Form.Item label="Nome Documento"
                name="nmDocumento"
                colon={false}
                rules={[
                  {
                    required: isCampoRequired("nmDocumento"),
                    message: "Campo Nome do Documento obrigatório não preenchido",
                  },
                ]}
              >
                <Input disabled={isCampoDisabled("nmDocumento")} placeholder="Digitar Nome" defaultValue={campoDefaultValue("nmDocumento")} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}
              style={{ display: hasCampo("nuDocumento") ? 'inline' : 'none' }}
            >
              <Form.Item label="Número Documento"
                name="nuDocumento"
                colon={false}
                rules={[
                  {
                    required: isCampoRequired("nuDocumento"),
                    message:
                      "Campo Número do Documento obrigatório não preechido",
                  },
                ]}
              >
                <Input disabled={isCampoDisabled("nuDocumento")} placeholder="Número" defaultValue={campoDefaultValue("nuDocumento")} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}
              style={{ display: hasCampo("nmOrgaoExpedidor") ? 'inline' : 'none' }}
            >
              <Form.Item label="Órgão Expedição"
                name="nmOrgaoExpedidor"
                colon={false}
                style={{ flexDirection: "column", alignItems: "flex-start" }}
                rules={[
                  {
                    required: isCampoRequired("nmOrgaoExpedidor"),
                    message: "Campo Órgão de Expedição obrigatório não preenchido",
                  },
                ]}
              >
                <Input disabled={isCampoDisabled("nmOrgaoExpedidor")} placeholder="Digitar Órgão" defaultValue={campoDefaultValue("nmOrgaoExpedidor")} />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={8} sm={4}
              style={{ display: hasCampo("nmEstado") ? 'inline' : 'none' }}
            >
              <Form.Item label="UF"
                name="nmEstado"
                //              labelCol={{span : 4}}
                colon={false}
                rules={[
                  {
                    required: isCampoRequired("nmEstado"),
                    message: "Campo Órgão de Expedição obrigatório não preenchido",
                  },
                ]}

              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='UF'
                  disabled={isCampoDisabled("nmEstado")}
                  defaultValue={campoDefaultValueSelect("nmEstado")}
                  onChange={(_, index) => {
                    handlerEstados(index);
                  }}
                >
                  {estados?.map((e: any) => (
                    <Option key={e.id} value={e.id}>
                      {e.sigla}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={16} sm={16}
              style={{ display: hasCampo("nmPais") ? 'inline' : 'none' }}
            >
              <Form.Item label='País'
                name='nmPais'
                labelCol={{ span: 16 }}
                labelAlign="left"
                colon={false}
              >
                <Select
                  style={{ width: 200 }}
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  disabled={isCampoDisabled("nmPais")}
                  defaultValue={campoDefaultValueSelect("nmPais")}
                  placeholder='País'
                  onChange={(_, index) => {
                    handlerPais(index);
                  }}
                >
                  {paises.map((e: IPais) => (
                    <Option key={e.idM49} value={e.idM49}>
                      {e.nome}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={8}
              style={{ display: hasCampo("dtExpedicao") ? 'inline' : 'none' }}
            >
              <Form.Item label="Data Expedição"
                name="dtExpedicao"
                colon={false}
                style={{ flexDirection: "column", alignItems: "flex-start" }}
                rules={[
                  {
                    required: isCampoRequired("dtExpedicao"),
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Selecionar Data"
                  disabledDate={disabledDate}
                  disabled={isCampoDisabled("dtExpedicao")}
                  defaultValue={campoDefaultValueDatePicker("dtExpedicao")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}
              style={{ display: hasCampo("dtValidade") ? 'inline' : 'none' }}
            >
              <Form.Item label="Data Validade"
                name="dtValidade"
                colon={false}
                style={{ flexDirection: "column", alignItems: "flex-start" }}
                rules={[
                  {
                    required: isCampoRequired("dtValidade"),
                    message: "Campo obrigatório",
                  },

                  {
                    validator: async (_, endDatetime) => {
                      let startDatetime = form.getFieldValue("dtExpedicao");
                      if (startDatetime){
                        if (endDatetime <= startDatetime) {
                          return Promise.reject(
                            "Data de validade deve ser maior do que a data de expedição."
                          );
                        }
                      }
                    },
                  },

                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Selecionar Data"
                  disabled={isCampoDisabled("dtValidade")}
                  defaultValue={campoDefaultValueDatePicker("dtValidade")}
                />
              </Form.Item>
            </Col>
          </Row>
{/*
Task 5444: Desativar armazenamento imagem de documento pessoal

          <Row justify="space-between">
            <Col xs={24} sm={12}>
              <SelecionarArquivo
                setChave={setChave}
                identificador={true}
                label=""
              />
            </Col>
          </Row>
*/}
        </Modal>
      </>

      <Row style={{ display: exibirDocCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={documentos} pagination={false} />
        </Col>
      </Row>
    </>
    //    </Card>
  )
};

export default DocPessoaFisica;